import { render, staticRenderFns } from "./TemplateDetailsPage.vue?vue&type=template&id=6a3d772a&scoped=true"
import script from "./TemplateDetailsPage.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailsPage.vue?vue&type=style&index=0&id=6a3d772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d772a",
  null
  
)

export default component.exports